import clsx from 'clsx';
import type { HTMLAttributes } from 'react';
import styles from './Pill.module.css';

export type PillTone = 'lime' | 'mint' | 'ink' | 'white' | 'warn' | 'saffron' | 'sand';

/** Small status / tag pill (`.pill .p-*`). */
export function Pill({ tone = 'mint', className, ...rest }: HTMLAttributes<HTMLSpanElement> & { tone?: PillTone }) {
  return <span className={clsx(styles.pill, styles[tone], className)} {...rest} />;
}
